import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {collection, collectionData, Firestore} from '@angular/fire/firestore';
import {listAll, ref, Storage} from '@angular/fire/storage';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject} from '@angular/core';

@Component({
  templateUrl: './comparaison-images.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DialogCompararaisonImageComponent {
  poteaux: any[] = [];

  constructor(
    private db: Firestore,
    private storage: Storage,
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<DialogCompararaisonImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    const poteauxRef = collection(this.db, `projets/${data.projet.id}/poteaux`);
    collectionData(poteauxRef).subscribe(async (datas: any) => {
      const sourcePoteaux = Array.isArray(datas) ? datas : Object.values(datas || {});

      this.poteaux = await Promise.all(
        sourcePoteaux
          .filter((p: any) => p && typeof p === 'object')
          .map(async (p: any) => {
            const poteauName = p.name ?? p.nom ?? p.id ?? 'Inconnu';
            const images = p.images;
            const telephoneImagesCount = Array.isArray(images)
              ? images.length
              : Object.values(images || {}).length;
            let serveurImagesCount = 0;

            try {
              const res = await listAll(ref(this.storage, `${this.data.projet.libelle}/images/${poteauName}`));
              serveurImagesCount = res.items.length;
            } catch {
              // Folder may not exist yet on storage; keep server count to 0.
            }

            return {
              name: poteauName,
              telephone: telephoneImagesCount,
              serveur: serveurImagesCount,
              ok: serveurImagesCount >= telephoneImagesCount,
              dateAdded: p.dateAdded
            };
          })
      );

      this.cdr.markForCheck();
    });
  }

  displayResult() {
    return this.poteaux.filter(x => !x.ok).length;
  }

  fermer(): void {
    this.dialogRef.close();
  }
}
